import { React, useState, useEffect } from 'react'


import "../css/ComponentStyle.css";
import { APIConstants, CommonAPIConstants } from '../utilities/Constants';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsRotate, faAnglesDown, faAnglesUp, faXmark, faArrowRight, faSpinner, faAnglesRight, faAngleLeft, faAnglesLeft, faPencil, faTrashCan, faFloppyDisk } from '@fortawesome/free-solid-svg-icons'

import { add, format, parse, set } from 'date-fns';
import { useDispatch } from 'react-redux';
import { setAuthToken } from '../redux/actions/userActions';
import { useParams } from 'react-router-dom'
import DatePicker from 'react-datepicker';
import { setDemoGraphyData } from '../redux/actions/userActions';
import AppointmentSection from './AppointmentSection';

const PrimaryInsurance = () => {

  const today = new Date();
  const formatCurDate = format(today, 'MM/dd/yyyy');

  const [pdata, setPdata] = useState([]);

  const [product, setProduct] = useState([]);
  const [tdata, setTdata] = useState([]);
  const [rdata, setRdata] = useState([]);
  const [denialRejectedData, setdenialRejectedData] = useState([]);
  const [graphData, setgraphData] = useState([]);
  const [chartdata, setChartdata] = useState([]);

  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState(''); // State to store start date
  const [endDate, setEndDate] = useState('');     // State to store end date
  const [selectDOSDate, setSelectDOSDate] = useState(formatCurDate);
  const [selectDOBDate, setSelectDOBDate] = useState(formatCurDate);
  const [loading, setLoading] = useState(true);
  const [hoveredDate, setHoveredDate] = useState(null);
  const [rowStartDate, setRowStartDate] = useState('');
  const [rowEndDate, setRowEndDate] = useState('');
  const [isRowStartOpen, setIsRowStartOpen] = useState(false);
  const [isRowEndOpen, setIsRowEndOpen] = useState(false);
  const [activeEndDate, setActiveEndDate] = useState('');

  const [isStartOpen, setIsStartOpen] = useState(false);
  const [isEndOpen, setIsEndOpen] = useState(false);
  const [isDosOpen, setIsDosOpen] = useState(false);
  const [isDOBOpen, setIsDOBOpen] = useState(false);
  const [isActiveEndDate, setIsActiveEndDate] = useState(false);
  const [calendarViewDate, setCalendarViewDate] = useState(new Date());

  const [showDetails, setShowDetails] = useState(false);
  const [primaryInsData, setPrimaryInsData] = useState([]);

  const [patientID, setpatientID] = useState('');
  const [rowState, setRowState] = useState({});
  const [insID, setInsID] = useState('');
  const [isHidden, setIsHidden] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isInStatus, setIsInStatus] = useState('');
  const [relationData, setRelationData] = useState([]);
  const [selectRelationValue, setselectRelationValue] = useState('1');

  const [selectedGendervalue, setSelectedGendervalue] = useState('');
  const [selectedInsvalue, setSelectedInsvalue] = useState('');
  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState('');
  const [selectedPlanName, setSelectedPlanName] = useState('');

  const [selectedFirstName, setSelectedFirstName] = useState('');
  const [selectedLastName, setSelectedLastName] = useState('');

  const [selectedDOB, setSelectedDOB] = useState('');
  const [selectedSSN, setSelectedSSN] = useState('');
  const [selectedAddr1, setSelectedAddr1] = useState('');
  const [selectedZIP, setSelectedZIP] = useState('');

  const [searchTextError, setSearchTextError] = useState(false);
  const [policyNumberError, setPolicyNumberError] = useState(false);
  const [startDateError, setStartDateError] = useState(false);
  const [editableRow, setEditableRow] = useState(null);

  const [selectedNewPolicyNumber, setSelectedNewPolicyNumber] = useState('');
  const [selectedNewPlanName, setSelectedNewPlanName] = useState('');
  const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
  const [showDeleteErrorModal, setShowDeleteErrorModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [activeConfirmModal, setActiveConfirmModal] = useState(false);

  const [selectPatientId, setSelectPatientId] = useState('');
  const [selectInsCoID, setSelectInsCoID] = useState('');
  const [selectInsTableID, setSelectInsTableID] = useState('');
  const [policyNumber, setPolicyNumber] = useState('');
  const [totalInsClaim, settotalInsClaim] = useState('');
  const [eligibilityData, setEligibilityData] = useState('');
  const [payerData, setPayerData] = useState('');
  const [receiverData, setReceiverData] = useState('');
  const [subscriberData, setSubscriberData] = useState('');
  const [addisubscriberData, setAddiSubscriberData] = useState('');
  const [benefitData, setBenefitData] = useState('');
  const [objPatData, setobjPatData] = useState('');
  const [coInsurance, setCoInsurance] = useState('');
  const [coPayment, setCoPayment] = useState('');
  const [deductibleDta, setDeductibleDta] = useState('');
  const [objProviderData, setobjProviderData] = useState('');
  const [activeRow, setActiveRow] = useState(null);


  const userData = useSelector((state) => state.user.user);

  const dispatch = useDispatch();



  const { id } = useParams();
  const PatientID = localStorage.setItem("PatientID", id);




  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;

  const sAuthToken = useSelector((state) => state.user.token);
  // const NewAuthToken = useSelector((state) => {
  //   const token = state.user.token;
  //   return token ?? state.user.user?.sAuthToken ?? '';
  // });

  console.log("PATIENT TOKEN:", sAuthToken);



  const handleStartDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setStartDate(formattedDate);

      setIsStartOpen(false)

    } else {
      setStartDate(null);
    }
  };


  const handleEndDateChange = (date) => {

    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setEndDate(formattedDate);

      setIsEndOpen(false)

    } else {
      setEndDate(null);
    }
  };




  const handleDOSDateChange = (date, id) => {
    if (date instanceof Date && !isNaN(date)) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setSelectDOSDate(prevDates => ({
        ...prevDates,
        [id]: formattedDate
      }));
      setIsDosOpen(prev => ({ ...prev, [id]: false }));
    } else {
      setSelectDOSDate(prevDates => ({ ...prevDates, [id]: null }));
    }
  };





  const getMonths = (selectedYear) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    return Array.from({ length: 12 }, (v, k) => {
      if (selectedYear === currentYear && k > currentMonth) {
        return null;
      }
      return (
        <option key={k} value={k}>
          {format(new Date(selectedYear, k), 'MMMM')}
        </option>
      );
    }).filter(option => option !== null);
  };





  const handleTodayClick = (dateType) => {
    const today = new Date();

    if (dateType === "start" && startDate) {
      setStartDate(today);

      setIsStartOpen(false);
    }

    if (dateType === "end" && endDate) {
      setEndDate(today);
      setIsEndOpen(false);
    }
    if (dateType === "dos" && selectDOSDate) {
      setSelectDOSDate(today);
      setIsDosOpen(false);
    }

    if (dateType === "dob" && selectDOBDate) {
      setSelectDOBDate(today);
      setIsDOBOpen(false);
    }

    if (dateType === "rowstart" && rowStartDate) {
      setRowStartDate(today);
      setIsRowStartOpen(false);
    }

    if (dateType === "rowend" && rowEndDate) {
      setRowEndDate(today);
      setIsRowEndOpen(false);
    }

    if (dateType === "active" && activeEndDate) {
      setActiveEndDate(today);
      setIsActiveEndDate(false);
    }

  };



  const CalendarContainer = ({ children }) => (
    <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
          Today
        </button>

      </div>
    </div>
  );


  const CalendarStartContainer = ({ children }) => (
    <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
          Today
        </button>

      </div>
    </div>
  );




  const CalendarRowStartContainer = ({ children }) => (
    <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleTodayClick("rowstart")}>
          Today
        </button>

      </div>
    </div>
  );


  const handleRowStartDateChange = (date) => {

    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setRowStartDate(formattedDate);

      setIsRowStartOpen(false)

    } else {
      setRowStartDate(null);
    }
  };









  const CalendarRowEndContainer = ({ children }) => (
    <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleTodayClick("rowend")}>
          Today
        </button>

      </div>
    </div>
  );


  const handleRowEndDateChange = (date) => {

    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setRowEndDate(formattedDate);

      setIsRowEndOpen(false)

    } else {
      setRowEndDate(null);
    }
  };



  const toggleCalendar = (id, open) => {
    setIsDosOpen(prev => ({ ...prev, [id]: open }));
  };










  const CalendarDOSContainer = ({ children, id }) => (
    <div style={{ zIndex: '99', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleDOSDateChange(new Date(), id)}>
          Today
        </button>
      </div>
    </div>
  );






  const handleDOBDateChange = (date) => {

    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setSelectDOBDate(formattedDate);

      setIsDOBOpen(false)

    } else {
      setSelectDOBDate(null);
    }
  };



  const CalendarDOBContainer = ({ children, id }) => (
    <div style={{ zIndex: '99', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleTodayClick("dob")}>
          Today
        </button>
      </div>
    </div>
  );





  const handleActiveEndDateChange = async (date) => {

    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setActiveEndDate(formattedDate);

      setIsActiveEndDate(false)






      const inpuJson = {


        objIns: {

          PatientID: id,
          EndDate: formattedDate,
          InsTblID: selectInsTableID,



        },


        objUser: {


          practiceID: userPracticeID,
          roleID: userData.roleID,
          userID: userId,


        }
      }


      const myInput = JSON.stringify(inpuJson);
      const inputData = JSON.stringify(myInput)


      try {
        const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.UpdatedActiveEndDate, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sAuthToken}`
          },
          body: inputData
        })



        if (response.status !== 200) {
          console.log("Error: Received response status", response.status);
          return;
        }



        const responseData = await response.json();




      } catch (error) {
        console.error('An error occurred:', error);
      }



    }

    else {
      setActiveEndDate(null);
    }


  };








  const CalendarActiveContainer = ({ children, id }) => (
    <div style={{ zIndex: '99', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '10px' }}>
        <button type="button" className='today-btn' onClick={() => handleTodayClick("active")}>
          Today
        </button>
      </div>
    </div>
  );









  const handleGetPatDemographyData = async () => {



    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientDemography}?PatientId=${id}`;



    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        const parsedData = JSON.parse(data)
        const demodata = JSON.parse(parsedData)
        dispatch(setDemoGraphyData(demodata))



      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }






  useEffect(() => {

    handleGetPatDemographyData();



  }, [])



  const handleGetRelationDropdown = async () => {


    const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetMasterRelation}`;



    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',


      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        const parsedData = JSON.parse(data)
        setRelationData(parsedData)



      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }




  useEffect(() => {
    document.title = 'Biller Dashboard'
    handleGetRelationDropdown();



  }, [])



  const handleGetPatInsurance = async () => {



    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatInsuranceDetails}?PatientId=${id}`;



    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        const parsedData = JSON.parse(data)
        const filterData = parsedData.filter(item => item.InsType == 1)
       
        setPrimaryInsData(filterData);
        // setSecondaryInsData(parsedData.filter(item => item.InsType === 2));
        setEligibilityData(filterData[0])



      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }




  useEffect(() => {

    handleGetPatInsurance();
  }, [])


  

  useEffect(() => {
  primaryInsData.forEach(item => {
    if (!selectDOSDate[item.InsTblID]) {
      setSelectDOSDate(prev => ({
        ...prev,
        [item?.InsTblID]: new Date().toISOString()
      }));
    }
  });
}, [primaryInsData]);



  const handleCheckeligibility = async (index, item) => {

    setRowState((prevState) => ({
      ...prevState,
      [insID]: { isLoading: true, isHidden: true, showIcon: true }
    }));


    const DOSValue = selectDOSDate[item?.InsTblID] || "";

    const selectedDataArray = [];


    setInsID(item?.InsTblID);

    setIsLoading(true);

    const eligibilityDOS = item.EligibilityDOS;


    var InsCountryId = item.PrimaryIns
    if (InsCountryId == null) {
      InsCountryId = ""
    }

    var PayerID = item.InsPayerID
    if (PayerID == null) {
      PayerID = ""
    }


    var inputStruct = {

      "PatientID": id,
      "PracticeID": userPracticeID,
      "PolicyNumber": item.InsPolicyNumber || "",
      "DOS": formatDOSDate(DOSValue) || "",
      "RowIndex": index,
      "UserID": userData ? userData.userID : 0
    };



    var objPatientDetails = {
      'objPatientDetails': inputStruct
    }
    var myInput = JSON.stringify(objPatientDetails);


    var myInput = JSON.stringify(objPatientDetails);
    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientEligibility}?sInputJSON=${myInput}`;

    console.log("Eligibility URL: ", url);
    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { }
        else return response.json();
      })


      .then((data) => {


        const responseData = data
        const parsedData = JSON.parse(responseData);


        setRowState((prevState) => ({
          ...prevState,
          [insID]: { isLoading: false, isHidden: false, showIcon: true },
        }));


        // setCheckEligibility(parsedData)



        var RowIndex = parsedData.RowIndex;
        var InsStatus = parsedData.InsStatus;
        setIsInStatus(parsedData.InsStatus);
        var EligibilityError = parsedData.EligibilityError;




        const payerIDElement = document.querySelector(`.payer${RowIndex}`);




        const filteredClaims = primaryInsData.filter((item) => {
          if (item?.InsTblID == insID) {
            if (payerIDElement) {
              if (parsedData.InsStatus === "Active") {
                payerIDElement.style.color = 'green';
              } else {
                payerIDElement.style.color = 'red';
              }
            }
          }


          return true;
        });

        setPrimaryInsData(filteredClaims);






      }).catch((error) => {
        console.error('An error occurred:', error);

        setRowState((prevState) => ({
          ...prevState,
          [insID]: { isLoading: false, isHidden: false, showIcon: true },
        }));



      })

  }











  const fetchInsuranceCompanies = () => {

    var inputJSON = {

      SearchKey: searchText,

    }

    var sJSONInput = JSON.stringify(inputJSON);


    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetInsuCompanyNames}?sJSONInput=${sJSONInput}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {


        const parsedData = JSON.parse(data);

        const InsuranceData = parsedData.Data




        if (Array.isArray(InsuranceData)) {

          const filteredSuggestions = InsuranceData

            .map(item => ({
              label: item.Insurance,
              val: item.InsuID,
            }))


          const filteredData = filteredSuggestions.filter(ins =>
            ins.label.toLowerCase().includes(searchText.toLowerCase())
          );

          setSuggestions(filteredData);

        } else {
          setSuggestions([]);

        }


      })

      .catch((error) => {
        console.error('Error fetching Insurance names:', error);

      });

    return [];

  };







  const handleInputChange = (e) => {
    const inputText = e.target.value;
    setSearchText(inputText);

    if (inputText.length > 0) {
      fetchInsuranceCompanies(inputText);
    } else {
      setSuggestions([]);
    }
  };





  const handleInsSuggestionList = (suggestion) => {
    setSearchText(`${suggestion.label}`);
    setSelectedInsvalue(`${suggestion.val}`);


    setSuggestions([]);
    //setSelectedSuggestion(suggestion.label);
  };


  const handleInsListKeyDown = (e) => {
    if (e.key === 'Backspace') {
      // Handle backspace key
      if (searchText === '') {
        // If input is empty and there are suggestions, remove the entire list
        setSuggestions([]);


      } else {
        const newSearchText = searchText.slice(0, -1);
        fetchInsuranceCompanies(newSearchText);

      }
    }
  }















  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };



  const formatDOSDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };






  const formatEndDate = (dateString) => {
    if (!dateString) {
      return "";
    }


    const specificDate = new Date("01/01/1900");
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "";
    }


    if (date.getTime() === specificDate.getTime()) {
      return "";
    }

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };





  useEffect(() => {
    if (primaryInsData && primaryInsData.length > 0) {
      setSelectedFirstName(primaryInsData[0].InsuredFName);
    }
  }, [primaryInsData]);





  useEffect(() => {
    if (primaryInsData && primaryInsData.length > 0) {
      setSelectedLastName(primaryInsData[0].InsuredLName);
    }
  }, [primaryInsData]);





  useEffect(() => {
    if (primaryInsData && primaryInsData.length > 0) {
      setSelectedSSN(primaryInsData[0].InsuredSSN);
    }
  }, [primaryInsData]);





  useEffect(() => {
    if (primaryInsData && primaryInsData.length > 0) {
      setSelectedAddr1(primaryInsData[0].InsuredAddress1);
    }
  }, [primaryInsData]);






  useEffect(() => {
    if (primaryInsData && primaryInsData.length > 0) {
      setSelectedZIP(primaryInsData[0].InsuredZIPCode);
    }
  }, [primaryInsData]);





  useEffect(() => {
    if (primaryInsData && primaryInsData.length > 0) {
      setSelectDOBDate(formatEndDate(primaryInsData[0].InsuredDOB));
    }
  }, [primaryInsData]);





  useEffect(() => {

    setActiveEndDate(new Date());

  }, [primaryInsData]);





  const handleSaveInsurance = async () => {


    setSearchTextError(!searchText);
    setPolicyNumberError(!selectedPolicyNumber);
    setStartDateError(!startDate);

    // Exit early if any fields are invalid
    if (!searchText || !selectedPolicyNumber || !startDate) {
      setShowSelectErrorModal(true)
      return;
    }


    setShowSelectErrorModal(false)

    var InsCity = primaryInsData?.[0]?.InsCity ?? "";
    if (InsCity == null) {
      InsCity = ""
    }

    var InsState = primaryInsData[0]?.InsState
    if (InsState == null) {
      InsState = ""
    }

    const inpuJson = {
      objUser: {


        practiceID: userPracticeID,
        roleID: userData.roleID,
        userID: userId,


      },



      objIns: {

        InsCoName: searchText,
        InsAddress1: selectedAddr1 + "",
        InsAddress2: primaryInsData[0]?.InsuredAddress2 ?? "",
        InsCity: InsCity ?? "",
        InsState: InsState ?? "",
        InsCityName: primaryInsData[0]?.InsCityName ?? "",
        InsStateName: primaryInsData[0]?.InsStateName ?? "",
        InsZip: selectedZIP + "",
        InsPolicyNumber: selectedPolicyNumber + "",
        InsPolicyName: selectedPlanName ?? "",
        PatientID: id,
        GrpName: primaryInsData[0]?.GrpName ?? "",
        InsuredFName: selectedFirstName + "",
        InsuredLName: selectedLastName + "",
        InsuredAddress1: selectedAddr1 + "",
        InsuredAddress2: primaryInsData[0]?.InsuredAddress2 ?? "",
        InsuredZIPCode: selectedZIP + "",
        InsuredCityID: primaryInsData[0]?.InsuredCityID ?? "",
        InsuredStateID: primaryInsData[0]?.InsuredStateID ?? "",
        InsuredRelationIndicator: selectRelationValue + "",
        InsCoID: selectedInsvalue ?? "",
        InsType: 1,
        InsuredSSN: selectedSSN ?? "",
        PhoneNumber: primaryInsData[0]?.PhoneNumber ?? "",
        InsuredDOB: selectedDOB + "",
        StartDate: startDate,
        EndDate: endDate ?? "",
        IsActiveforBilling: 1,



      }
    }




    const myInput = JSON.stringify(inpuJson);
    const inputData = JSON.stringify(myInput)


    try {
      const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.SavePatientInsurance, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`
        },
        body: inputData
      })



      if (response.status !== 200) {
        console.log("Error: Received response status", response.status);
        return;
      }



      const responseData = await response.json();




      if (responseData > 0) {
        const newRowData = {
          InsCoName: searchText,
          InsPolicyNumber: selectedPolicyNumber,
          StartDate: startDate,
          EndDate: endDate,
          InsuredRelation: selectRelationValue ?? "",
          InsPolicyName: selectedPlanName ?? "",

          InsuredFName: selectedFirstName ?? "",
          InsuredLName: selectedLastName ?? "",
          InsuredAddress1: selectedAddr1 ?? "",
          InsurerGenderDes: selectedGendervalue ?? "",
          InsuredDOB: selectedDOB ?? "",
          InsuredSSN: selectedSSN ?? "",
          InsuredZIPCode: selectedZIP ?? "",
        };


        setPrimaryInsData((prevData) => [...prevData, newRowData]);

      }



      setSearchText('')
      setSelectedPolicyNumber('')



    } catch (error) {
      console.error('An error occurred:', error);
    }
  };




  const handleCloseModals = () => {

    setShowSelectErrorModal(false);
    setShowDeleteErrorModal(false);
    setShowConfirmModal(false);
    setActiveConfirmModal(false);
  }




  const handleEditRow = (index, item) => {
    setEditableRow(index === editableRow ? null : index);
    setSelectedNewPolicyNumber(item.InsPolicyNumber)
    setRowStartDate(item.StartDate)
    setRowEndDate(item.EndDate)
    setSelectedNewPlanName(item.InsPolicyName)
  };








  const handleUpdatedPatInsurance = async (item) => {


    const inpuJson = {
      objUser: {


        practiceID: userPracticeID,
        roleID: userData.roleID,
        userID: userId,


      },



      objIns: {

        PatientID: id,
        InsTblID: item?.InsTblID,
        InsPolicyName: selectedNewPlanName + "",
        StartDate: formatDOSDate(rowStartDate),
        EndDate: formatEndDate(rowEndDate),
        InsType: item.InsType + "",
        InsPolicyNumber: selectedNewPolicyNumber,



      }
    }




    const myInput = JSON.stringify(inpuJson);
    const inputData = JSON.stringify(myInput)


    try {
      const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.UpdatedPatInsurance, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`
        },
        body: inputData
      })



      if (response.status !== 200) {
        console.log("Error: Received response status", response.status);
        return;
      }



      const responseData = await response.json();



      if (responseData === 1) {

        setPrimaryInsData(prevData =>
          prevData.map(ins =>
            ins.InsTblID === item?.InsTblID ? {
              ...ins,
              InsPolicyNumber: selectedNewPolicyNumber,
              StartDate: formatDOSDate(rowStartDate),
              EndDate: formatEndDate(rowEndDate),
              InsPolicyName: selectedNewPlanName

            } : ins
          )
        )

      }

      setEditableRow(null);



    } catch (error) {
      console.error('An error occurred:', error);
    }
  };









  const handleDeleteModal = async (item) => {

    setSelectPatientId(item.PatientID);
    setSelectInsCoID(item.InsCoID);
    setSelectInsTableID(item.InsTblID);




    if (item.PatInsClaims > 0) {
      setShowDeleteErrorModal(true)
      return;
    }

    else {
      setShowSelectErrorModal(false)
      setShowConfirmModal(true)

    }


  }








  const handleDeleteInsurance = async () => {


    const selectedData = {

      objIns: {

        PatientID: selectPatientId + "",
        InsCoID: selectInsCoID,
        InsTblID: selectInsTableID
      },

      objUser: {

        practiceID: userPracticeID,
        roleID: userData.roleID,
        userID: userId,


      }

    }




    var sInputData = JSON.stringify(selectedData);

    var sInputJson = JSON.stringify(sInputData);



    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.DeletePrimaryInsurance}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      },
      body: sInputJson
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        // const parsedData = JSON.parse(data)

        if (data > 0) {

          setPrimaryInsData(prevData =>
            prevData.filter(ins => ins.InsTblID !== selectInsTableID)
          );
          setShowConfirmModal(false)
        }
        else {
          console.error('Failed to delete the insurance record');
        }



      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }






  const handleMarkInsModal = async (item) => {

    setSelectPatientId(item.PatientID);
    setSelectInsCoID(item.InsCoID);
    setSelectInsTableID(item.InsTblID);
    setPolicyNumber(item.InsPolicyNumber)
    settotalInsClaim(item.PatInsClaims)


    setActiveConfirmModal(true)



  }





  const handleMarkInactiveInsurance = async (e) => {




    const inpuJson = {
      objUser: {


        practiceID: userPracticeID,
        roleID: userData.roleID,
        userID: userId,


      },



      objIns: {

        PatientID: id,
        InsCoID: selectInsCoID,
        InsTblID: selectInsTableID,
        InsPolicyNumber: policyNumber,


      }
    }


    const myInput = JSON.stringify(inpuJson);
    const inputData = JSON.stringify(myInput)


    try {
      const response = await fetch(APIConstants.PATIENT_PORTAL_URL + CommonAPIConstants.MarkInsuraceInactive, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`
        },
        body: inputData
      })



      if (response.status !== 200) {
        console.log("Error: Received response status", response.status);
        return;
      }



      const responseData = await response.json();




      if (responseData === 1) {


        setPrimaryInsData(prevData =>
          prevData.map(ins =>
            ins.InsTblID === selectInsTableID
              ? { ...ins, InsPolicyNumber: policyNumber, IsActiveforBilling: 0, EndDate: activeEndDate }
              : ins
          )
        );
      }


      setActiveConfirmModal(false)



    } catch (error) {
      console.error('An error occurred:', error);
    }
  };







  const handlePatEligibilityDetails = (item) => {

    const DOSValue = selectDOSDate[item?.InsTblID] || "";

    setPayerData("");
    setReceiverData("")
    setSubscriberData("")
    setBenefitData("")
    setobjPatData("")
    setAddiSubscriberData("")
    setCoInsurance("")
    setCoPayment("")
    setDeductibleDta("")
    setobjProviderData("")

    var jsoninput = {
      PatientID: item?.PatientID,
      InsCompanyID: item?.InsCoID,
      PolicyNumber: item?.InsPolicyNumber,
      UserID: userData ? userData.userID : 0,
      DOS: formatDOSDate(DOSValue) || ""
    }



    var inputJSON = JSON.stringify({ 'objPatientDetails': jsoninput });




    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.PatientEligibilityDetails}?sInputJSON=${inputJSON}`;

    console.log("Check eligibility URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sAuthToken}`
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {


        const parsedData = JSON.parse(data);

        setPayerData(parsedData.objPayer);
        setReceiverData(parsedData.objReceiver)
        setSubscriberData(parsedData.objSubscriber)
        setBenefitData(parsedData.objBenefit)
        setobjPatData(parsedData.objPatient)
        setAddiSubscriberData(parsedData.objSubAddtlInfo)
        setCoInsurance(parsedData.objCoInsurace)
        setCoPayment(parsedData.objCopayment)
        setDeductibleDta(parsedData.objDeductible)
        setobjProviderData(parsedData.ojbProvider)
        //handleGetPatInsurance();


      })

      .catch((error) => {
        console.error('Error fetching Insurance names:', error);

      });


  };


  useEffect(() => {



    handlePatEligibilityDetails(eligibilityData);


  }, [eligibilityData])




  useEffect(() => {
    if (selectRelationValue === "1") {
      setShowDetails(false);


    } else {
      setShowDetails(true);
      setSelectedFirstName("");
      setSelectedLastName("");
      setSelectedGendervalue("");
      setSelectDOBDate("");
      setSelectedSSN("");
      setSelectedAddr1("");
      setSelectedZIP("");
    }
  }, [selectRelationValue]);





  const handleRowClick = (index) => {
    setActiveRow(index);
  };







  return (
    <>


      <div style={{ height: 'auto' }}>
        <div className='mt=1 ml-1'>

          <div className='subtable-container' >
            <table className="table table-hover table-striped table-bordered border-secondary table-info responsive mt-1" style={{ marginLeft: '4px' }}>

              <thead>

                <tr className='align-top' >

                  <th className='col-sm col-th  text-white' style={{ backgroundColor: '#0173b7' }}>#</th>

                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }} onClick={handleGetPatInsurance}>Ins Type

                  </th>
                  <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7', width: '180px' }}>Ins Company

                  </th>

                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Policy Number

                  </th>

                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>Start Date

                  </th>




                  <th className='col col-th-style text-white ' style={{ backgroundColor: '#0173b7' }}>End Date


                  </th>
                  <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }}>DOS


                  </th>

                  <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }}>Eligibility

                  </th>


                  <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }}>CheckedBy


                  </th>
                  <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }}>Plan Name

                  </th>
                  <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }} onClick={handleGetRelationDropdown}>Relation
                    <FontAwesomeIcon icon={showDetails ? faAnglesLeft : faAnglesRight} onClick={toggleDetails} />
                  </th>


                  {showDetails && (
                    <>

                      <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }}>

                        First Name
                      </th>

                      <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }}>
                        Last Name
                      </th>

                      <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }}>
                        Gender
                      </th>

                      <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }}>
                        DOB
                      </th>



                      <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }}>
                        SSN
                      </th>

                      <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }}>
                        Address 1
                      </th>
                      <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }}>
                        ZIP
                      </th>

                    </>

                  )}

                  <th className='col col-th-style text-white' style={{ backgroundColor: '#0173b7' }}>Edit/Delete

                  </th>


                </tr>


              </thead>

              <tbody>

                <tr>

                  <th></th>
                  <td>

                  </td>
                  <td>
                    <input
                      type='text'
                      value={searchText}
                      onChange={handleInputChange}
                      onKeyDown={handleInsListKeyDown}
                      style={{ backgroundColor: searchTextError ? 'lightcoral' : '', width: '130px' }}

                    />
                    <div className='autocomplete'>
                      <ul className='list-style' style={{ fontSize: '0.9rem' }}>
                        {suggestions.map((suggestion) => (
                          <li key={suggestion.val} onClick={() => handleInsSuggestionList(suggestion)}>{suggestion.label}</li>
                        ))}
                      </ul>
                    </div>
                  </td>
                  <td>
                    <input type='text'
                      style={{ backgroundColor: policyNumberError ? 'lightcoral' : '', width: '150px' }}
                      value={selectedPolicyNumber}
                      onChange={(e) => setSelectedPolicyNumber(e.target.value)}
                    />
                  </td>
                  <td>
                    <div className="datepicker-container mt-1 d-flex" style={{ marginLeft: '1px', position: 'relative', zIndex: 10 }}>

                      <DatePicker
                        style={{ backgroundColor: startDateError ? 'lightcoral' : '' }}
                        selected={startDate ? new Date(startDate) : null}
                        onChange={handleStartDateChange}
                        dateFormat="MM/dd/yyyy"
                        maxDate={new Date()}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        yearDropdownItemNumber={100}

                        className={`clnImgTextBoxes ${startDate ? 'default-selected' : ''}`}
                        placeholderText="MM/dd/yyyy"
                        calendarContainer={CalendarStartContainer}
                        open={isStartOpen}
                        onFocus={() => setIsStartOpen(true)}
                        onInputClick={() => setIsStartOpen(true)}
                        onClickOutside={() => setIsStartOpen(false)}
                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                          const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                          const selectedMonth = selectedDate.getMonth();
                          const selectedYear = selectedDate.getFullYear();

                          return (
                            <div>
                              <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                {"<"}
                              </button>
                              <select
                                value={selectedMonth}
                                onChange={({ target: { value } }) => changeMonth(Number(value))}
                              >
                                {getMonths(selectedYear)}
                              </select>
                              <select
                                value={selectedYear}
                                onChange={({ target: { value } }) => changeYear(Number(value))}
                              >
                                {Array.from({ length: 100 }, (v, k) => (
                                  <option key={k} value={new Date().getFullYear() - k}>
                                    {new Date().getFullYear() - k}
                                  </option>
                                ))}
                              </select>
                              <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                {">"}
                              </button>
                            </div>
                          );
                        }}
                      />
                    </div>

                  </td>
                  <td>

                    <div className="datepicker-container  mt-1 d-flex" style={{ marginLeft: '1px', position: 'relative', zIndex: 10 }}>

                      <DatePicker
                        selected={endDate ? new Date(endDate) : null}
                        onChange={handleEndDateChange}
                        dateFormat="MM/dd/yyyy"
                        maxDate={new Date()}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        yearDropdownItemNumber={100}
                        className={`clnImgTextBoxes ${endDate ? 'default-selected' : ''}`}
                        placeholderText="MM/dd/yyyy"
                        popperPlacement="bottom-start"

                        calendarContainer={CalendarContainer}
                        open={isEndOpen}
                        onFocus={() => setIsEndOpen(true)}
                        onInputClick={() => setIsEndOpen(true)}
                        onClickOutside={() => setIsEndOpen(false)}
                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                          const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                          const selectedMonth = selectedDate.getMonth();
                          const selectedYear = selectedDate.getFullYear();

                          return (
                            <div>
                              <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                {"<"}
                              </button>
                              <select
                                value={selectedMonth}
                                onChange={({ target: { value } }) => changeMonth(Number(value))}
                              >
                                {getMonths(selectedYear)}
                              </select>
                              <select
                                value={selectedYear}
                                onChange={({ target: { value } }) => changeYear(Number(value))}
                              >
                                {Array.from({ length: 100 }, (v, k) => (
                                  <option key={k} value={new Date().getFullYear() - k}>
                                    {new Date().getFullYear() - k}
                                  </option>
                                ))}
                              </select>
                              <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                {">"}
                              </button>
                            </div>
                          );
                        }}
                      />
                    </div>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <input type='text'
                      style={{ width: '150px' }}
                      value={selectedPlanName}
                      onChange={(e) => setSelectedPlanName(e.target.value)}
                    />
                  </td>
                  <td>

                    <>
                      <select name="select" style={{ height: '25px', width: '80px' }}
                        value={selectRelationValue}
                        onChange={(e) => setselectRelationValue(e.target.value)}
                      >
                        {relationData.map((item, index) => (
                          <option value={item.RelationId} >{item.Relation}</option>
                        ))}
                      </select>
                    </>

                  </td>
                  {showDetails && (
                    <>
                      <td>
                        <input type='text'
                          style={{ backgroundColor: selectRelationValue !== "1" ? "lightcoral" : "white" }}
                          value={selectedFirstName}
                          onChange={(e) => setSelectedFirstName(e.target.value)}
                        />
                      </td>
                      <td>
                        <input type='text'
                          style={{ backgroundColor: selectRelationValue !== "1" ? "lightcoral" : "white" }}
                          value={selectedLastName}
                          onChange={(e) => setSelectedLastName(e.target.value)}
                        />
                      </td>
                      <td>


                        <select name="select" style={{ height: '25px', width: '80px' }}

                          value={selectedGendervalue}
                          onChange={(e) => setSelectedGendervalue(e.target.value)}
                        >

                          <option value="1" >Male</option>

                          <option value="2" >Female</option>
                          <option value="3" >Others</option>
                        </select>
                      </td>
                      <td>
                        <DatePicker
                          selected={selectDOBDate ? new Date(selectDOBDate) : ""}
                          onChange={handleDOBDateChange}
                          dateFormat="MM/dd/yyyy"
                          maxDate={new Date()}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          yearDropdownItemNumber={100}
                          className={`clnImgTextBoxes ${selectDOBDate ? 'default-selected' : ''}`}
                          placeholderText="MM/dd/yyyy"
                          popperPlacement="bottom-start"

                          calendarContainer={CalendarDOBContainer}
                          open={isDOBOpen}
                          onFocus={() => setIsDOBOpen(true)}
                          onInputClick={() => setIsDOBOpen(true)}
                          onClickOutside={() => setIsDOBOpen(false)}
                          renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                            const selectedMonth = selectedDate.getMonth();
                            const selectedYear = selectedDate.getFullYear();

                            return (
                              <div>
                                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                  {"<"}
                                </button>
                                <select
                                  value={selectedMonth}
                                  onChange={({ target: { value } }) => changeMonth(Number(value))}
                                >
                                  {getMonths(selectedYear)}
                                </select>
                                <select
                                  value={selectedYear}
                                  onChange={({ target: { value } }) => changeYear(Number(value))}
                                >
                                  {Array.from({ length: 100 }, (v, k) => (
                                    <option key={k} value={new Date().getFullYear() - k}>
                                      {new Date().getFullYear() - k}
                                    </option>
                                  ))}
                                </select>
                                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                  {">"}
                                </button>
                              </div>
                            );
                          }}
                        />

                      </td>
                      <td>
                        <input type='text'
                          style={{ backgroundColor: selectRelationValue !== "1" ? "lightcoral" : "white", width: '80px' }}
                          value={selectedSSN}
                          onChange={(e) => setSelectedSSN(e.target.value)}
                        />
                      </td>
                      <td>
                        <input type='text'
                          style={{ backgroundColor: selectRelationValue !== "1" ? "lightcoral" : "white" }}
                          value={selectedAddr1}
                          onChange={(e) => setSelectedAddr1(e.target.value)}
                        />
                      </td>
                      <td>
                        <input type='text'
                          style={{ backgroundColor: selectRelationValue !== "1" ? "lightcoral" : "white", width: '80px' }}
                          value={selectedZIP}
                          onChange={(e) => setSelectedZIP(e.target.value)}
                        />
                      </td>
                    </>
                  )}


                  <td>
                    <button className='diagbtn-style' style={{ marginLeft: '10px' }} onClick={handleSaveInsurance}>Save</button>
                  </td>

                </tr>



                {primaryInsData.map((item, index) => (

                  <tr
                    className={`
                    ${item?.PatInsStatus === "active" || item?.EligibilityResp === "success" ? "table-success" : ""}
                    ${item?.PatInsStatus === "inactive" || (item?.EligibilityResp !== "") ? "table-danger" : ""}
                    ${activeRow === index ? "table-warning" : ""}
                  `}

                    data-toggle="tooltip"
                    data-placement="top"
                    title={item.EligibilityError || ''}
                    key={index}

                    onClick={(e) => {
                      handlePatEligibilityDetails(item);
                      handleRowClick(index);
                    }}

                  >

                    <th>{index + 1}</th>
                    <td>

                      {editableRow === index ? (
                        <select name="select" style={{ height: '25px', width: '80px' }}
                          value={selectedInsvalue}
                          onChange={(e) => setSelectedInsvalue(e.target.value)}
                        >

                          <option value="1" >Primary</option>

                          <option value="2" >Secondary</option>

                        </select>

                      ) : (

                        <label>Primary</label>
                      )}

                    </td>
                    <td>
                      <label>{item.InsCoName}</label>
                      <br />
                      (T-{item.PayerID || ""}, O-{item.OptumPayerID || ""})
                    </td>
                    <td>


                      {editableRow === index ? (
                        <input type="text" className="form-control"

                          value={selectedNewPolicyNumber}
                          onChange={(e) => setSelectedNewPolicyNumber(e.target.value)}
                        />
                      ) : (
                        <label className={`payer${index}`}>{item.InsPolicyNumber}</label>
                      )}
                      <br />



                      {item.IsActiveforBilling !== 0 && (
                        <button className='diagbtn-style' onClick={(e) => handleMarkInsModal(item)}>Mark as Inactive</button>
                      )}
                    </td>
                    <td>

                      {editableRow === index ? (
                        <DatePicker

                          selected={rowStartDate ? new Date(rowStartDate) : ""}
                          onChange={handleRowStartDateChange}
                          dateFormat="MM/dd/yyyy"
                          maxDate={new Date()}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          yearDropdownItemNumber={100}
                          className={`clnImgTextBoxes ${rowStartDate ? 'default-selected' : ''}`}
                          placeholderText="MM/dd/yyyy"
                          popperPlacement="bottom-start"

                          calendarContainer={CalendarRowStartContainer}
                          open={isRowStartOpen}
                          onFocus={() => setIsRowStartOpen(true)}
                          onInputClick={() => setIsRowStartOpen(true)}
                          onClickOutside={() => setIsRowStartOpen(false)}
                          renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                            const selectedMonth = selectedDate.getMonth();
                            const selectedYear = selectedDate.getFullYear();

                            return (
                              <div style={{ zIndex: 9000, position: 'absolute' }}>
                                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                  {"<"}
                                </button>
                                <select
                                  value={selectedMonth}
                                  onChange={({ target: { value } }) => changeMonth(Number(value))}
                                >
                                  {getMonths(selectedYear)}
                                </select>
                                <select
                                  value={selectedYear}
                                  onChange={({ target: { value } }) => changeYear(Number(value))}
                                >
                                  {Array.from({ length: 100 }, (v, k) => (
                                    <option key={k} value={new Date().getFullYear() - k}>
                                      {new Date().getFullYear() - k}
                                    </option>
                                  ))}
                                </select>
                                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                  {">"}
                                </button>
                              </div>
                            );
                          }}
                        />
                      ) : (
                        <label>{formatDOSDate(item.StartDate)}</label>
                      )}
                    </td>
                    <td>
                      {editableRow === index ? (
                        <DatePicker

                          selected={rowEndDate ? new Date(rowEndDate) : ""}
                          onChange={handleRowEndDateChange}
                          dateFormat="MM/dd/yyyy"
                          maxDate={new Date()}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          yearDropdownItemNumber={100}
                          className={`clnImgTextBoxes ${rowEndDate ? 'default-selected' : ''}`}
                          placeholderText="MM/dd/yyyy"
                          popperPlacement="bottom-start"

                          calendarContainer={CalendarRowEndContainer}
                          open={isRowEndOpen}
                          onFocus={() => setIsRowEndOpen(true)}
                          onInputClick={() => setIsRowEndOpen(true)}
                          onClickOutside={() => setIsRowEndOpen(false)}
                          renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                            const selectedMonth = selectedDate.getMonth();
                            const selectedYear = selectedDate.getFullYear();

                            return (
                              <div style={{ zIndex: 9000, position: 'absolute' }}>
                                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                  {"<"}
                                </button>
                                <select
                                  value={selectedMonth}
                                  onChange={({ target: { value } }) => changeMonth(Number(value))}
                                >
                                  {getMonths(selectedYear)}
                                </select>
                                <select
                                  value={selectedYear}
                                  onChange={({ target: { value } }) => changeYear(Number(value))}
                                >
                                  {Array.from({ length: 100 }, (v, k) => (
                                    <option key={k} value={new Date().getFullYear() - k}>
                                      {new Date().getFullYear() - k}
                                    </option>
                                  ))}
                                </select>
                                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                  {">"}
                                </button>
                              </div>
                            );
                          }}
                        />
                      ) : (
                        <label>{formatEndDate(item.EndDate)}</label>
                      )}
                    </td>
                    <td>
                      <DatePicker

                        selected={selectDOSDate[item.InsTblID] ? new Date(selectDOSDate[item.InsTblID]) : new Date()}
                        onChange={(date) => handleDOSDateChange(date, item.InsTblID)}
                        dateFormat="MM/dd/yyyy"
                        maxDate={new Date()}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        yearDropdownItemNumber={100}
                        className={`clnImgTextBoxes ${selectDOSDate ? 'default-selected' : ''}`}
                        placeholderText="MM/dd/yyyy"
                        popperPlacement="bottom-start"

                        calendarContainer={(props) => <CalendarDOSContainer {...props} id={item.InsTblID} />}

                        open={isDosOpen[item.InsTblID] || false}
                        onFocus={() => toggleCalendar(item.InsTblID, true)}
                        onInputClick={() => toggleCalendar(item.InsTblID, true)}
                        onClickOutside={() => toggleCalendar(item.InsTblID, false)}
                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                          const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                          const selectedMonth = selectedDate.getMonth();
                          const selectedYear = selectedDate.getFullYear();

                          return (
                            <div>
                              <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                {"<"}
                              </button>
                              <select
                                value={selectedMonth}
                                onChange={({ target: { value } }) => changeMonth(Number(value))}
                              >
                                {getMonths(selectedYear)}
                              </select>
                              <select
                                value={selectedYear}
                                onChange={({ target: { value } }) => changeYear(Number(value))}
                              >
                                {Array.from({ length: 100 }, (v, k) => (
                                  <option key={k} value={new Date().getFullYear() - k}>
                                    {new Date().getFullYear() - k}
                                  </option>
                                ))}
                              </select>
                              <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                {">"}
                              </button>
                            </div>
                          );
                        }}
                      />

                      <br />
                      <button className='diagbtn-style' style={{ marginLeft: '10px' }} onClick={(e) => handleCheckeligibility(index, item)}>Check</button>

                      {rowState[item.InsTblID]?.isHidden && (
                        <FontAwesomeIcon
                          style={{ marginLeft: '5px' }}
                          icon={faSpinner}
                          className={rowState[item.InsTblID]?.isLoading ? 'rotating-icon' : ''}
                        />
                      )}

                    </td>
                    <td>
                      <label>{item.InsStatus}</label>
                    </td>
                    <td>{item.EligibilityCheckedBy}- {formatEndDate(item.EligibilityCheckedDate || "")}</td>
                    <td>

                      {editableRow === index ? (
                        <input type="text" className="form-control"

                          value={selectedNewPlanName}
                          onChange={(e) => setSelectedNewPlanName(e.target.value)}
                        />
                      ) : (
                        <label>{item.InsPolicyName ? item.InsPolicyName : ""}</label>
                      )}
                    </td>


                    <td>{item.InsuredRelation}</td>


                    {showDetails && (
                      <>
                        <td>{item.InsuredFName}</td>
                        <td>{item.InsuredLName}</td>
                        <td>{item.InsurerGenderDes}</td>
                        <td>{formatEndDate(item.InsuredDOB)}</td>
                        <td>{item.InsuredSSN}</td>
                        <td>{item.InsuredAddress1}</td>
                        <td>{item.InsuredZIPCode}</td>
                      </>
                    )}

                    <td>
                      {editableRow === index ? (
                        <FontAwesomeIcon icon={faFloppyDisk} onClick={() => handleUpdatedPatInsurance(item)} />
                      ) : (
                        <>
                          <FontAwesomeIcon style={{ cursor: 'pointer', marginLeft: '5px' }} onClick={() => handleEditRow(index, item)} icon={faPencil} />
                          <FontAwesomeIcon style={{ cursor: 'pointer', marginLeft: '5px' }} onClick={() => handleDeleteModal(item)} icon={faTrashCan} />
                        </>
                      )}
                    </td>


                  </tr>



                )
                )}
              </tbody>





              {showSelectErrorModal && (

                <div className='alert-modal'>

                  <p className='mt-3'>Please fill the Required Fields!!</p>
                  <button className='btn btn-danger' style={{ width: '50px', height: '30px', padding: '4px' }} onClick={handleCloseModals}>Ok</button>

                </div>

              )}



              {showDeleteErrorModal && (

                <div className='alert-modal'>

                  <p className='mt-3'>This insurance is linked to claims. Can not delete insurance !!</p>
                  <button className='btn btn-danger' style={{ width: '50px', height: '30px', padding: '4px' }} onClick={handleCloseModals}>Ok</button>

                </div>

              )}



              {showConfirmModal && (

                <div className='alert-modal'>

                  <p>Are you sure to delete ?</p>
                  <button className='btn btn-primary' onClick={handleCloseModals}>cancel</button>
                  <button className='btn btn-primary' style={{ marginLeft: '40px' }} onClick={handleDeleteInsurance} >Delete</button>
                </div>
              )}




              {activeConfirmModal && (

                <div className='inactive-modal' >
                  <label>CONFIRM</label>

                  <p>Are you sure you want to do this?</p>

                  <p> This change could affect {`${totalInsClaim}`} active claims for this patient.</p>


                  <div >

                    <label style={{ backgroundColor: '#18A6EC', color: 'white' }}>End Date :</label>


                    <DatePicker

                      selected={activeEndDate ? new Date(activeEndDate) : new Date()}
                      onChange={handleActiveEndDateChange}
                      dateFormat="MM/dd/yyyy"
                      maxDate={new Date()}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      yearDropdownItemNumber={100}
                      className={`clnImgTextBoxes ${activeEndDate ? 'default-selected' : ''}`}
                      placeholderText="MM/dd/yyyy"
                      popperPlacement="bottom-start"

                      calendarContainer={CalendarActiveContainer}
                      open={isActiveEndDate}
                      onFocus={() => setIsActiveEndDate(true)}
                      onInputClick={() => setIsActiveEndDate(true)}
                      onClickOutside={() => setIsActiveEndDate(false)}
                      renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                        const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                        const selectedMonth = selectedDate.getMonth();
                        const selectedYear = selectedDate.getFullYear();

                        return (
                          <div style={{ backgroundColor: '#18A6EC' }}>
                            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                              {"<"}
                            </button>
                            <select
                              value={selectedMonth}
                              onChange={({ target: { value } }) => changeMonth(Number(value))}
                            >
                              {getMonths(selectedYear)}
                            </select>
                            <select
                              value={selectedYear}
                              onChange={({ target: { value } }) => changeYear(Number(value))}
                            >
                              {Array.from({ length: 100 }, (v, k) => (
                                <option key={k} value={new Date().getFullYear() - k}>
                                  {new Date().getFullYear() - k}
                                </option>
                              ))}
                            </select>
                            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                              {">"}
                            </button>
                          </div>
                        );
                      }}
                    />

                  </div>




                  <br />

                  <button className='btn btn-danger mt-1' style={{ width: '50px', height: '30px', padding: '4px' }} onClick={(e) => handleMarkInactiveInsurance(e)}>Yes</button>
                  <button className='btn btn-danger mt-1' style={{ width: '50px', height: '30px', padding: '4px', marginLeft: '10px' }} onClick={handleCloseModals}>No</button>
                </div>
              )}


            </table>



          </div>





          <div className="gvheader" style={{ textAlign: 'center' }}>Eligibility Details</div>
          <div>
            <label id="eligibilitmessageLabel"></label>
            <table width="100%" cellspacing="1" id="EligibilityReport" visible="false">

              <tr className="rows">
                <td align="center" colspan="2"><b>Payer</b></td>

              </tr>
              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Name:</td>
                <td width="70%">
                  <b>

                    <label ID="lblPayerName" style={{ paddingLeft: '5px' }}> {payerData.PayerName || ""}</label>

                  </b>
                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Payer identification:</td>
                <td width="70%">
                  <b>
                    {payerData ? (
                      <label ID="lblIdentification" style={{ paddingLeft: '5px' }}>{payerData.PayerID}</label>
                    ) :
                      (
                        <label ID="lblIdentification" style={{ paddingLeft: '5px' }}></label>
                      )
                    }
                  </b>


                </td>
              </tr>

              <tr className="rows" >
                <td colspan="2" style={{ borderBottom: '1px solid red' }}></td>
              </tr>


              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Eligibility or Benefit:</td>
                <td width="70%">
                  <table width="100%">
                    <tr>
                      <td width="30%">
                        <b>

                          <label ID="lblEBAC" style={{ paddingLeft: '5px', width: '160px', color: 'green' }} >{benefitData[0]?.BenefitInfo || ""}</label>
                          <label ID="lblEBAC2" style={{ paddingLeft: '5px', width: '160px', color: 'green' }} >{benefitData[1]?.BenefitInfo}</label>
                        </b>
                      </td>
                      <td>
                        <b>

                        </b>

                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Coverage:</td>
                <td width="70%">
                  <table width="100%">
                    <tr>
                      <td width="30%">
                        <b>
                          <label ID="lblEBACCoverage" style={{ paddingLeft: '5px', width: '35%' }}>{benefitData[0]?.CoverageLevel}</label>
                        </b>
                      </td>
                      <td>
                        <b>
                          <label ID="lblEBACCoverage2" style={{ paddingLeft: '5px', width: '35%' }}></label>
                        </b>
                      </td>
                    </tr>
                  </table>

                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Service Type:</td>
                <td width="70%">
                  <table width="100%">
                    <tr>
                      <td width="30%">
                        <b>
                          <label ID="lblEBACServicetype" style={{ paddingLeft: '5px', width: '85%' }}>{benefitData[0]?.ServiceType}</label>
                        </b>
                      </td>
                      <td>
                        <b>
                          <label ID="lblEBACServicetype2" style={{ paddingLeft: '5px', width: '35%' }}></label>
                        </b>

                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Insurance Type:</td>
                <td width="70%">
                  <table width="100%">
                    <tr>
                      <td width="30%">
                        <b>
                          <label ID="lblEBACInsurancetype" style={{ paddingLeft: '5px', width: 'auto' }}>{benefitData[0]?.InsuranceType}</label>
                        </b>
                      </td>
                      <td>
                        <b>
                          <label ID="lblEBACInsurancetype2" style={{ paddingLeft: '5px', width: '35%' }}></label>
                        </b>

                      </td>
                    </tr>
                  </table>

                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Plan Coverage Description:</td>
                <td width="70%">
                  <table width="100%">
                    <tr>
                      <td width="30%">
                        <b>
                          <label ID="lblEBACPlanCdesc" style={{ paddingLeft: '5px', width: 'auto' }}>{benefitData[0]?.PlanCoverageDescription}</label>
                        </b>
                      </td>
                      <td>
                        <b>
                          <label ID="lblEBACPlanCdesc2" style={{ paddingLeft: '5px', width: '35%' }}></label>
                        </b>

                      </td>
                    </tr>
                  </table>
                </td>
              </tr>


              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Eligibility Begin:</td>
                <td width="70%">
                  <table width="100%">
                    <tr>
                      <td width="30%">
                        <b>
                          <label ID="lblEBACPEB" style={{ paddingLeft: '5px', width: '35%' }} ></label>
                        </b>
                      </td>
                      <td>
                        <b>
                          <label ID="lblEBACPEB2" style={{ paddingLeft: '5px', width: '35%' }} ></label>
                        </b>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>


              <tr className="rows" >
                <td colspan="2" style={{ borderBottom: '1px solid red' }}></td>
              </tr>

              <tr className="rows">
                <td align="center" colspan="2"><b>Information Receiver</b></td>

              </tr>
              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Type:</td>
                <td width="70%">
                  <b>
                    <label ID="lblrecType" style={{ paddingLeft: '5px' }}></label>
                  </b>

                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Name:</td>
                <td width="70%">
                  <b>
                    <label ID="lblrecName">{objProviderData.LastName}</label>
                  </b>


                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>National provider identifier(NPI):</td>
                <td width="70%">
                  <b>
                    <label ID="lblrecnpi" style={{ paddingRight: '5px' }}>{receiverData.NPI}</label>
                  </b>


                </td>
              </tr>

              <tr className="rows" >

                <td colspan="2" style={{ borderBottom: '1px solid red' }}></td>
              </tr>

              <tr className="rows">
                <td align="center" colspan="2"><b>Insured or Subscriber</b></td>

              </tr>
              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Name:</td>
                <td width="70%">
                  <b>
                    {objPatData ? (
                      <label ID="lblIORName" style={{ paddingLeft: '5px' }}>{objPatData.LastName},{objPatData.FirstName}</label>
                    ) : (
                      <label ID="lblIORName" style={{ paddingLeft: '5px' }}></label>
                    )
                    }
                  </b>

                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Member Identification Number:</td>
                <td width="70%">
                  <b>
                    <label ID="lblIORMIN" style={{ paddingLeft: '5px' }}>{subscriberData.PolicyNumber}</label>
                  </b>


                </td>
              </tr>


              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Case Number:</td>
                <td width="70%">
                  <b>
                    <label ID="lblIORCaseNumber" style={{ paddingLeft: '5px' }}>{addisubscriberData.GroupPolicyNumber}</label>
                  </b>


                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Description:</td>
                <td width="70%">
                  <b>
                    <label ID="lblIORDesc" style={{ paddingLeft: '5px' }}>{addisubscriberData.PlansSponsor}</label>
                  </b>


                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Address:</td>
                <td width="70%">
                  <b>


                    {objPatData ? (
                      <label ID="lblIORAddress" style={{ paddingLeft: '5px' }}>
                        {objPatData.Address},{objPatData.City},{objPatData.State},{objPatData.Zip}
                      </label>

                    ) : (
                      <label></label>
                    )

                    }

                  </b>


                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>DOB:</td>
                <td width="70%">

                  <b>
                    <label ID="lblIORDOB" style={{ paddingLeft: '5px' }}>{formatEndDate(subscriberData.DOB)}</label>
                  </b>

                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Gender:</td>
                <td width="70%">
                  <b>
                    <label ID="lblIORGender" style={{ paddingLeft: '5px' }}>{subscriberData.Gender}</label>
                  </b>

                </td>
              </tr>

              <tr className="rows">
                <td colspan="2" style={{ borderBottom: '1px solid red' }}></td>

              </tr>


              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Eligibility or Benefit:</td>
                <td width="70%">
                  {
                    coInsurance ? (
                      <>
                        <label ID="lblCOINEOB" style={{ paddingLeft: '5px', color: 'purple' }}>Co-Insurance</label>
                        <label ID="lblCOINEOB2" style={{ paddingLeft: '5px', color: 'purple' }}>Co-Insurance</label>
                      </>
                    ) : (

                      <>
                        <label ID="lblCOINEOB" style={{ paddingLeft: '5px' }}></label>
                        <label ID="lblCOINEOB2" style={{ paddingLeft: '5px' }}></label>
                      </>
                    )
                  }

                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Coverage:</td>
                <td width="70%">
                  <label ID="lblCOINCoverage" style={{ paddingLeft: '5px' }}>{coInsurance[0]?.CoverageLevel}
                  </label>
                  <label ID="lblCOINCoverage2" style={{ paddingLeft: '5px' }}>{coInsurance[1]?.CoverageLevel}</label>

                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Service Type:</td>
                <td width="70%">
                  <label ID="lblCOINServicetype" style={{ paddingLeft: '5px' }}>{coInsurance[0]?.ServiceType}</label>
                  <label ID="lblCOINServicetype2" style={{ paddingLeft: '5px' }}>{coInsurance[1]?.ServiceType}</label>

                </td>
              </tr>


              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Insurance Type:</td>
                <td width="70%">
                  <label ID="lblCOINInsurancetype" style={{ paddingLeft: '5px' }}>{coInsurance[0]?.InsuranceType}</label>
                  <label ID="lblCOINInsurancetype2" style={{ paddingLeft: '5px' }}>{coInsurance[1]?.InsuranceType}</label>

                </td>
              </tr>


              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Plan Coverage Description:</td>
                <td width="70%">
                  <label ID="lblCOINPCD" style={{ paddingLeft: '5px' }}>{coInsurance[0]?.PlanCoverageDescription}</label>
                  <label ID="lblCOINPCD2" style={{ paddingLeft: '5px' }}>{coInsurance[1]?.PlanCoverageDescription}</label>

                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Percent:</td>
                <td width="70%">
                  <label ID="lblCOIPercent" style={{ paddingLeft: '5px' }}>{coInsurance[0]?.Percentage}</label>
                  <label ID="lblCOIPercent2" style={{ paddingLeft: '5px' }}>{coInsurance[1]?.Percentage}</label>
                </td>
              </tr>

              <tr className="rows">
                <td colspan="2" style={{ borderBottom: '1px solid red' }}></td>

              </tr>



              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Eligibility or Benefit:</td>
                <td width="70%">
                  {
                    coPayment ? (
                      <>
                        <label ID="lblCOPAYEOB" style={{ paddingLeft: '5px', color: 'purple' }}>Co-Payment</label>
                        <label ID="lblCOPAYEOB2" style={{ paddingLeft: '5px', color: 'purple' }}>Co-Payment</label>
                      </>
                    ) : (
                      <>
                        <label ID="lblCOPAYEOB" style={{ paddingLeft: '5px' }}></label>
                        <label ID="lblCOPAYEOB2" style={{ paddingLeft: '5px' }}></label>

                      </>

                    )
                  }

                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Coverage:</td>
                <td width="70%">
                  <label ID="lblCOPAYCoverage" style={{ paddingLeft: '5px' }}>{coPayment[0]?.CoverageLevel}</label>
                  <label ID="lblCOPAYCoverage2" style={{ paddingLeft: '5px' }}>{coPayment[1]?.CoverageLevel}</label>

                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Service Type:</td>
                <td width="70%">
                  <label ID="lblCOPAYServicetype" style={{ paddingLeft: '5px' }}>{coPayment[0]?.ServiceType}</label>
                  <label ID="lblCOPAYServicetype2" style={{ paddingLeft: '5px' }}>{coPayment[1]?.ServiceType}</label>

                </td>
              </tr>


              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Insurance Type:</td>
                <td width="70%">
                  <label ID="lblCOPAYItype" style={{ paddingLeft: '5px' }}>{coPayment[0]?.InsuranceType}</label>
                  <label ID="lblCOPAYItype2" style={{ paddingLeft: '5px' }}>{coPayment[1]?.InsuranceType}</label>
                </td>
              </tr>


              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Plan Coverage Description:</td>
                <td width="70%">
                  <label ID="lblCOPAYPCD" style={{ paddingLeft: '5px' }}>{coPayment[0]?.PlanCoverageDescription}</label>
                  <label ID="lblCOPAYPCD2" style={{ paddingLeft: '5px' }}>{coPayment[1]?.PlanCoverageDescription}</label>
                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Monetary Amount:</td>
                <td width="70%">
                  <label ID="lblCOPAYMAmount" style={{ paddingLeft: '5px' }}>{coPayment[0]?.BenefitAmount}</label>
                  <label ID="lblCOPAYMAmount2" style={{ paddingLeft: '5px' }}>{coPayment[1]?.BenefitAmount}</label>
                </td>
              </tr>

              <tr className="rows">
                <td colspan="2" style={{ borderBottom: '1px solid red' }}></td>

              </tr>



              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Eligibility or Benefit:</td>
                <td width="70%">
                  {
                    deductibleDta ? (
                      <>
                        <label ID="lblSecDeductEOB" style={{ paddingLeft: '5px', color: 'purple' }}>Deductible</label>
                        <label ID="lblSecDeductEOB2" style={{ paddingLeft: '5px', color: 'purple' }}>Deductible</label>
                      </>
                    ) : (
                      <>
                        <label ID="lblSecDeductEOB" style={{ paddingLeft: '5px' }}></label>
                        <label ID="lblSecDeductEOB2" style={{ paddingLeft: '5px' }}></label>

                      </>
                    )
                  }
                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Coverage:</td>
                <td width="70%">
                  <label ID="lblDeductCoverage" style={{ paddingLeft: '5px' }}>{deductibleDta[0]?.CoverageLevel}</label>
                  <label ID="lblDeductCoverage2" style={{ paddingLeft: '5px' }}>{deductibleDta[1]?.CoverageLevel}</label>

                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Service Type:</td>
                <td width="70%">
                  <label ID="lblSecDeductServicetype" style={{ paddingLeft: '5px' }}>{deductibleDta[0]?.ServiceType}</label>
                  <label ID="lblSecDeductServicetype2" style={{ paddingLeft: '5px' }}>{deductibleDta[1]?.ServiceType}</label>
                </td>
              </tr>


              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Insurance Type:</td>
                <td width="70%">
                  <label ID="lblSecDeductInsurancetype" style={{ paddingLeft: '5px' }}>{deductibleDta[0]?.InsuranceType}</label>
                  <label ID="lblSecDeductInsurancetype2" style={{ paddingLeft: '5px' }}>{deductibleDta[1]?.InsuranceType}</label>
                </td>
              </tr>


              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Plan Coverage Description:</td>
                <td width="70%">
                  <label ID="lblDeductPCD" style={{ paddingLeft: '5px' }}>{deductibleDta[0]?.PlanCoverageDescription}</label>
                  <label ID="lblDeductPCD2" style={{ paddingLeft: '5px' }}>{deductibleDta[1]?.PlanCoverageDescription}</label>
                </td>
              </tr>

              <tr className="rows">
                <td align="right" width="30%" style={{ paddingRight: '5px' }}>Monetary Amount:</td>
                <td width="70%">
                  <label ID="lblSecDeductMA" style={{ paddingLeft: '5px' }}>{deductibleDta[0]?.BenefitAmount}</label>
                  <label ID="lblSecDeductMA2" style={{ paddingLeft: '5px' }}>{deductibleDta[1]?.BenefitAmount}</label>
                </td>
              </tr>


            </table>
          </div>






        </div>
      </div>





    </>
  )
}

export default PrimaryInsurance
